/** 路由白名单 */
export const routeWhiteList = [
  "/login",
  "/nsearch",
  "/minisearch",
  "/minisearchByNo",
  "/openMini",
  "/mini/business",
  "/autologin",
  "/sign",
  "/miniShare",
  "/video/chat",
  "/mobile/to-sign",
  "/mobile/progress",
  "/mobile/record-video",
  "/mobile/card",
  "/mobile/connect",
  "/mobile/video",
  "/mobile/guard",
  "/mobile/finish",
  "/mobile/fundVerfy",
  "/mobile/fundFinish",
  "/mobile/fundDocument",
  "/mobile/watch-video",
  "/mobile/preview-document",
  "/mobile/procureVerfy",
  "/mobile/procureFinish",
  "/mobile/procureDocument",
  "/mobile/remoteVideo",
  "/mobile/remoteVideo/chat",
  "/mobile/qa-result",
  "/mobile/factoringVerfy",
  "/mobile/factoringFinish",
  "/mobile/factoringDocument",
  "/mobile/microcreditVerfy",
  "/mobile/microcreditFinish",
  "/mobile/microcreditDocument",
  "/tcfb",
  "/tcfblist",
  "/hp",
  "/pgz/*",
  "/sr",
  "/error/403",
  "/error/404",
  "/error/500",
  "/playvideo",
  "/business/api/index",
  "/spay/*"
];
